(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4111,59654,55004,6050,12701,54223,59679],{

/***/ 32924:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof self !== 'undefined' ? self : {};

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var blocks = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.BLOCKS = void 0;
/**
 * Map of all Contentful block types. Blocks contain inline or block nodes.
 */
var BLOCKS;
(function (BLOCKS) {
    BLOCKS["DOCUMENT"] = "document";
    BLOCKS["PARAGRAPH"] = "paragraph";
    BLOCKS["HEADING_1"] = "heading-1";
    BLOCKS["HEADING_2"] = "heading-2";
    BLOCKS["HEADING_3"] = "heading-3";
    BLOCKS["HEADING_4"] = "heading-4";
    BLOCKS["HEADING_5"] = "heading-5";
    BLOCKS["HEADING_6"] = "heading-6";
    BLOCKS["OL_LIST"] = "ordered-list";
    BLOCKS["UL_LIST"] = "unordered-list";
    BLOCKS["LIST_ITEM"] = "list-item";
    BLOCKS["HR"] = "hr";
    BLOCKS["QUOTE"] = "blockquote";
    BLOCKS["EMBEDDED_ENTRY"] = "embedded-entry-block";
    BLOCKS["EMBEDDED_ASSET"] = "embedded-asset-block";
    BLOCKS["TABLE"] = "table";
    BLOCKS["TABLE_ROW"] = "table-row";
    BLOCKS["TABLE_CELL"] = "table-cell";
    BLOCKS["TABLE_HEADER_CELL"] = "table-header-cell";
})(BLOCKS = exports.BLOCKS || (exports.BLOCKS = {}));

});

unwrapExports(blocks);
var blocks_1 = blocks.BLOCKS;

var inlines = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.INLINES = void 0;
/**
 * Map of all Contentful inline types. Inline contain inline or text nodes.
 */
var INLINES;
(function (INLINES) {
    INLINES["HYPERLINK"] = "hyperlink";
    INLINES["ENTRY_HYPERLINK"] = "entry-hyperlink";
    INLINES["ASSET_HYPERLINK"] = "asset-hyperlink";
    INLINES["EMBEDDED_ENTRY"] = "embedded-entry-inline";
})(INLINES = exports.INLINES || (exports.INLINES = {}));

});

unwrapExports(inlines);
var inlines_1 = inlines.INLINES;

var marks = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Map of all Contentful marks.
 */
var MARKS;
(function (MARKS) {
    MARKS["BOLD"] = "bold";
    MARKS["ITALIC"] = "italic";
    MARKS["UNDERLINE"] = "underline";
    MARKS["CODE"] = "code";
    MARKS["SUPERSCRIPT"] = "superscript";
    MARKS["SUBSCRIPT"] = "subscript";
})(MARKS || (MARKS = {}));
exports.default = MARKS;

});

unwrapExports(marks);

var schemaConstraints = createCommonjsModule(function (module, exports) {
var __spreadArray = (commonjsGlobal && commonjsGlobal.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.V1_MARKS = exports.V1_NODE_TYPES = exports.TEXT_CONTAINERS = exports.HEADINGS = exports.CONTAINERS = exports.VOID_BLOCKS = exports.TABLE_BLOCKS = exports.LIST_ITEM_BLOCKS = exports.TOP_LEVEL_BLOCKS = void 0;


var marks_1 = __importDefault(marks);
/**
 * Array of all top level block types.
 * Only these block types can be the direct children of the document.
 */
exports.TOP_LEVEL_BLOCKS = [
    blocks.BLOCKS.PARAGRAPH,
    blocks.BLOCKS.HEADING_1,
    blocks.BLOCKS.HEADING_2,
    blocks.BLOCKS.HEADING_3,
    blocks.BLOCKS.HEADING_4,
    blocks.BLOCKS.HEADING_5,
    blocks.BLOCKS.HEADING_6,
    blocks.BLOCKS.OL_LIST,
    blocks.BLOCKS.UL_LIST,
    blocks.BLOCKS.HR,
    blocks.BLOCKS.QUOTE,
    blocks.BLOCKS.EMBEDDED_ENTRY,
    blocks.BLOCKS.EMBEDDED_ASSET,
    blocks.BLOCKS.TABLE,
];
/**
 * Array of all allowed block types inside list items
 */
exports.LIST_ITEM_BLOCKS = [
    blocks.BLOCKS.PARAGRAPH,
    blocks.BLOCKS.HEADING_1,
    blocks.BLOCKS.HEADING_2,
    blocks.BLOCKS.HEADING_3,
    blocks.BLOCKS.HEADING_4,
    blocks.BLOCKS.HEADING_5,
    blocks.BLOCKS.HEADING_6,
    blocks.BLOCKS.OL_LIST,
    blocks.BLOCKS.UL_LIST,
    blocks.BLOCKS.HR,
    blocks.BLOCKS.QUOTE,
    blocks.BLOCKS.EMBEDDED_ENTRY,
    blocks.BLOCKS.EMBEDDED_ASSET,
];
exports.TABLE_BLOCKS = [
    blocks.BLOCKS.TABLE,
    blocks.BLOCKS.TABLE_ROW,
    blocks.BLOCKS.TABLE_CELL,
    blocks.BLOCKS.TABLE_HEADER_CELL,
];
/**
 * Array of all void block types
 */
exports.VOID_BLOCKS = [blocks.BLOCKS.HR, blocks.BLOCKS.EMBEDDED_ENTRY, blocks.BLOCKS.EMBEDDED_ASSET];
/**
 * Dictionary of all container block types, and the set block types they accept as children.
 *
 * Note: This does not include `[BLOCKS.DOCUMENT]: TOP_LEVEL_BLOCKS`
 */
exports.CONTAINERS = (_a = {},
    _a[blocks.BLOCKS.OL_LIST] = [blocks.BLOCKS.LIST_ITEM],
    _a[blocks.BLOCKS.UL_LIST] = [blocks.BLOCKS.LIST_ITEM],
    _a[blocks.BLOCKS.LIST_ITEM] = exports.LIST_ITEM_BLOCKS,
    _a[blocks.BLOCKS.QUOTE] = [blocks.BLOCKS.PARAGRAPH],
    _a[blocks.BLOCKS.TABLE] = [blocks.BLOCKS.TABLE_ROW],
    _a[blocks.BLOCKS.TABLE_ROW] = [blocks.BLOCKS.TABLE_CELL, blocks.BLOCKS.TABLE_HEADER_CELL],
    _a[blocks.BLOCKS.TABLE_CELL] = [blocks.BLOCKS.PARAGRAPH],
    _a[blocks.BLOCKS.TABLE_HEADER_CELL] = [blocks.BLOCKS.PARAGRAPH],
    _a);
/**
 * Array of all heading levels
 */
exports.HEADINGS = [
    blocks.BLOCKS.HEADING_1,
    blocks.BLOCKS.HEADING_2,
    blocks.BLOCKS.HEADING_3,
    blocks.BLOCKS.HEADING_4,
    blocks.BLOCKS.HEADING_5,
    blocks.BLOCKS.HEADING_6,
];
/**
 * Array of all block types that may contain text and inline nodes.
 */
exports.TEXT_CONTAINERS = __spreadArray([blocks.BLOCKS.PARAGRAPH], exports.HEADINGS, true);
/**
 * Node types before `tables` release.
 */
exports.V1_NODE_TYPES = [
    blocks.BLOCKS.DOCUMENT,
    blocks.BLOCKS.PARAGRAPH,
    blocks.BLOCKS.HEADING_1,
    blocks.BLOCKS.HEADING_2,
    blocks.BLOCKS.HEADING_3,
    blocks.BLOCKS.HEADING_4,
    blocks.BLOCKS.HEADING_5,
    blocks.BLOCKS.HEADING_6,
    blocks.BLOCKS.OL_LIST,
    blocks.BLOCKS.UL_LIST,
    blocks.BLOCKS.LIST_ITEM,
    blocks.BLOCKS.HR,
    blocks.BLOCKS.QUOTE,
    blocks.BLOCKS.EMBEDDED_ENTRY,
    blocks.BLOCKS.EMBEDDED_ASSET,
    inlines.INLINES.HYPERLINK,
    inlines.INLINES.ENTRY_HYPERLINK,
    inlines.INLINES.ASSET_HYPERLINK,
    inlines.INLINES.EMBEDDED_ENTRY,
    'text',
];
/**
 * Marks before `superscript` & `subscript` release.
 */
exports.V1_MARKS = [marks_1.default.BOLD, marks_1.default.CODE, marks_1.default.ITALIC, marks_1.default.UNDERLINE];

});

unwrapExports(schemaConstraints);
var schemaConstraints_1 = schemaConstraints.V1_MARKS;
var schemaConstraints_2 = schemaConstraints.V1_NODE_TYPES;
var schemaConstraints_3 = schemaConstraints.TEXT_CONTAINERS;
var schemaConstraints_4 = schemaConstraints.HEADINGS;
var schemaConstraints_5 = schemaConstraints.CONTAINERS;
var schemaConstraints_6 = schemaConstraints.VOID_BLOCKS;
var schemaConstraints_7 = schemaConstraints.TABLE_BLOCKS;
var schemaConstraints_8 = schemaConstraints.LIST_ITEM_BLOCKS;
var schemaConstraints_9 = schemaConstraints.TOP_LEVEL_BLOCKS;

var types = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

});

unwrapExports(types);

var nodeTypes = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

});

unwrapExports(nodeTypes);

var emptyDocument = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

/**
 * A rich text document considered to be empty.
 * Any other document structure than this is not considered empty.
 */
var EMPTY_DOCUMENT = {
    nodeType: blocks.BLOCKS.DOCUMENT,
    data: {},
    content: [
        {
            nodeType: blocks.BLOCKS.PARAGRAPH,
            data: {},
            content: [
                {
                    nodeType: 'text',
                    value: '',
                    marks: [],
                    data: {},
                },
            ],
        },
    ],
};
exports.default = EMPTY_DOCUMENT;

});

unwrapExports(emptyDocument);

var helpers = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.isText = exports.isBlock = exports.isInline = void 0;


/**
 * Tiny replacement for Object.values(object).includes(key) to
 * avoid including CoreJS polyfills
 */
function hasValue(obj, value) {
    for (var _i = 0, _a = Object.keys(obj); _i < _a.length; _i++) {
        var key = _a[_i];
        if (value === obj[key]) {
            return true;
        }
    }
    return false;
}
/**
 * Checks if the node is an instance of Inline.
 */
function isInline(node) {
    return hasValue(inlines.INLINES, node.nodeType);
}
exports.isInline = isInline;
/**
 * Checks if the node is an instance of Block.
 */
function isBlock(node) {
    return hasValue(blocks.BLOCKS, node.nodeType);
}
exports.isBlock = isBlock;
/**
 * Checks if the node is an instance of Text.
 */
function isText(node) {
    return node.nodeType === 'text';
}
exports.isText = isText;

});

unwrapExports(helpers);
var helpers_1 = helpers.isText;
var helpers_2 = helpers.isBlock;
var helpers_3 = helpers.isInline;

var dist = createCommonjsModule(function (module, exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.helpers = exports.EMPTY_DOCUMENT = exports.MARKS = exports.INLINES = exports.BLOCKS = void 0;

Object.defineProperty(exports, "BLOCKS", { enumerable: true, get: function () { return blocks.BLOCKS; } });

Object.defineProperty(exports, "INLINES", { enumerable: true, get: function () { return inlines.INLINES; } });

Object.defineProperty(exports, "MARKS", { enumerable: true, get: function () { return __importDefault(marks).default; } });
__exportStar(schemaConstraints, exports);
__exportStar(types, exports);
__exportStar(nodeTypes, exports);

Object.defineProperty(exports, "EMPTY_DOCUMENT", { enumerable: true, get: function () { return __importDefault(emptyDocument).default; } });
var helpers$1 = __importStar(helpers);
exports.helpers = helpers$1;

});

unwrapExports(dist);
var dist_1 = dist.helpers;
var dist_2 = dist.EMPTY_DOCUMENT;
var dist_3 = dist.MARKS;
var dist_4 = dist.INLINES;
var dist_5 = dist.BLOCKS;

/**
 * Returns the text value of a rich text document.
 *
 * NB: This can be applied to non text node of a structured text document,
 * hence the flexible typing.
 */
function documentToPlainTextString(rootNode, blockDivisor) {
    if (blockDivisor === void 0) { blockDivisor = ' '; }
    if (!rootNode || !rootNode.content) {
        /**
         * Handles edge cases, such as when the value is not set in the CMA or the
         * field has not been properly validated, e.g. because of a user extension.
         * Note that we are nevertheless strictly type-casting `rootNode` as
         * Block | Inline. Valid rich text documents (and their branch block nodes)
         * should never lack a Node[] `content` property.
         */
        return '';
    }
    /**
     * Algorithm notes: We only want to apply spacing when a node is part of a
     * sequence. This is tricky because nodes can often be deeply nested within
     * non-semantic content arrays. For example, to get the text value of an
     * unordered list, we have to traverse like so:
     *
     * {
     *   nodeType: BLOCKS.UL_LIST,
     *   data: {},
     *   content: [
     *     {
     *       nodeType: BLOCKS.LIST_ITEM,
     *       data: {},
     *       content: [{
     *         nodeType: BLOCKS.PARAGRAPH,
     *         data: {},
     *         content: [
     *           { nodeType: 'text', data: {}, value: 'List ', marks: [] },
     *           { nodeType: 'text', data: {}, value: 'item', marks: [{ type: 'bold' }] }
     *         ]
     *       }]
     *     },
     *     {
     *       nodeType: BLOCKS.LIST_ITEM,
     *       data: {},
     *       content: [{
     *         nodeType: BLOCKS.PARAGRAPH,
     *         data: {},
     *         content: [
     *           { nodeType: 'text', data: {}, value: 'Another list item', marks: [] }
     *         ]
     *       }]
     *     },
     *     {
     *       nodeType: BLOCKS.LIST_ITEM,
     *       data: {},
     *       content: [{
     *         nodeType: BLOCKS.HR,
     *         data: {},
     *         content: [],
     *       }]
     *     },
     *     {
     *       nodeType: BLOCKS.LIST_ITEM,
     *       data: {},
     *       content: [{
     *         nodeType: BLOCKS.PARAGRAPH,
     *         data:
     *         content: [
     *           { nodeType: 'text', data: {}, value: 'Yet another list item', marks: [] }
     *         ]
     *       }]
     *     },
     *   }]
     * }
     *
     * We want there to be a space between 'List item' and 'Another list item' (to
     * denote a visual line break, which conventionally appears between non-text
     * node sequences) but not a redundant space between 'List ' and 'item'.
     * Moreover, we want just a _singular_ space between 'Another list item' and
     * 'Yet another list item' - the non-semantic HR between the two nodes should
     * not denote an additional space.
     */
    return rootNode.content.reduce(function (acc, node, i) {
        var nodeTextValue;
        if (dist_1.isText(node)) {
            nodeTextValue = node.value;
        }
        else if (dist_1.isBlock(node) || dist_1.isInline(node)) {
            nodeTextValue = documentToPlainTextString(node, blockDivisor);
            if (!nodeTextValue.length) {
                return acc;
            }
        }
        var nextNode = rootNode.content[i + 1];
        var isNextNodeBlock = nextNode && dist_1.isBlock(nextNode);
        var divisor = isNextNodeBlock ? blockDivisor : '';
        return acc + nodeTextValue + divisor;
    }, '');
}

exports.a = documentToPlainTextString;
//# sourceMappingURL=rich-text-plain-text-renderer.es5.js.map


/***/ }),

/***/ 10928:
/***/ (function(module) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),

/***/ 41910:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/works/[project]",
      function () {
        return __webpack_require__(38175);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 59654:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _utils_useTypography__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18422);






var Typography = function(props) {
    var _ref = (0,_utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .useTypography */ .tj)(props), Tag = _ref.Tag, classes = _ref.classes, children = _ref.children, onClick = _ref.onClick, tabIndex = _ref.tabIndex, role = _ref.role, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, [
        "Tag",
        "classes",
        "children",
        "onClick",
        "tabIndex",
        "role"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tag, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        className: classes,
        onClick: onClick,
        tabIndex: tabIndex,
        role: role
    }, rest), {
        children: children
    }));
};
Typography.defaultProps = {
    variant: _utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .TYPOGRAPHY_TAGS.p */ .w1.p,
    size: _utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .TYPOGRAPHY_SIZE.paragrapgh16 */ .y3.paragrapgh16
};
Typography.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().node.isRequired),
    isBold: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().bool),
    variant: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    size: prop_types__WEBPACK_IMPORTED_MODULE_5___default().oneOf(Object.values(_utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .TYPOGRAPHY_SIZE */ .y3)),
    mobileSize: prop_types__WEBPACK_IMPORTED_MODULE_5___default().oneOf(Object.values(_utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .TYPOGRAPHY_SIZE */ .y3)),
    onClick: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().func),
    tabIndex: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    role: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string)
};
/* harmony default export */ __webpack_exports__["default"] = (Typography);


/***/ }),

/***/ 18422:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "tj": function() { return /* binding */ useTypography; },
/* harmony export */   "w1": function() { return /* binding */ TYPOGRAPHY_TAGS; },
/* harmony export */   "y3": function() { return /* binding */ TYPOGRAPHY_SIZE; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2664);
/* harmony import */ var redux_selectors_layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19341);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34461);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_4__);







var TYPOGRAPHY_TAGS = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    p: "p",
    span: "span"
};
var TYPOGRAPHY_SIZE = {
    caption12: "caption",
    paragrapgh14: "paragrapgh-s",
    paragrapgh16: "paragrapgh-m",
    headline20: "headline-xs",
    headline24: "headline-s",
    headline38: "headline-m",
    headline46: "headline-l",
    headline56: "headline-xl"
};
var useTypography = function(_param) {
    var variant = _param.variant, isBold = _param.isBold, className = _param.className, children = _param.children, size = _param.size, mobileSize = _param.mobileSize, onClick = _param.onClick, tabIndex = _param.tabIndex, role = _param.role, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "variant",
        "isBold",
        "className",
        "children",
        "size",
        "mobileSize",
        "onClick",
        "tabIndex",
        "role"
    ]);
    var isDesktopResolution = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__.useSelector)(redux_selectors_layout__WEBPACK_IMPORTED_MODULE_3__/* .selectIsDesktop */ .Y6);
    var Tag = TYPOGRAPHY_TAGS[variant] || variant;
    var actualSize = isDesktopResolution || !mobileSize ? size : mobileSize;
    var classes = classnames__WEBPACK_IMPORTED_MODULE_0___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().typography), className, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default())[actualSize], (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().boldText), isBold));
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        Tag: Tag,
        children: children,
        classes: classes,
        onClick: onClick,
        tabIndex: tabIndex,
        role: role
    }, rest);
};


/***/ }),

/***/ 38175:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _project_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
;// CONCATENATED MODULE: ./components/CaseStudiesCommon/index.jsx





var IntroRefactored = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(15680), __webpack_require__.e(25631), __webpack_require__.e(40659)]).then(__webpack_require__.bind(__webpack_require__, 25631));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(25631)
            ];
        }
    }
});
var ProjectIdeaRefactored = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(15680), __webpack_require__.e(4557)]).then(__webpack_require__.bind(__webpack_require__, 4557));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4557)
            ];
        }
    }
});
var ResultsSectionRefactored = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(64157)]).then(__webpack_require__.bind(__webpack_require__, 51781));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(51781)
            ];
        }
    }
});
var ImagesSectionRefactored = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(15680), __webpack_require__.e(53435), __webpack_require__.e(81066)]).then(__webpack_require__.bind(__webpack_require__, 53435));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(53435)
            ];
        }
    }
});
var WireframesSectionRefactored = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(99756), __webpack_require__.e(19750)]).then(__webpack_require__.bind(__webpack_require__, 64757));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(64757)
            ];
        }
    }
});
var SpecialChallengesAndSolutionsRefactored = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(15680), __webpack_require__.e(30719), __webpack_require__.e(90324), __webpack_require__.e(59873)]).then(__webpack_require__.bind(__webpack_require__, 20597));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(20597)
            ];
        }
    }
});
var ChallengesAndSolutionsWithWireframesRefactored = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(15680), __webpack_require__.e(30719), __webpack_require__.e(99756), __webpack_require__.e(90324), __webpack_require__.e(26174), __webpack_require__.e(34359)]).then(__webpack_require__.bind(__webpack_require__, 75033));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(75033)
            ];
        }
    }
});
var CaseParallax = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(17173)]).then(__webpack_require__.bind(__webpack_require__, 97736));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(97736)
            ];
        }
    }
});
var CaseStudyDesign = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(95778)]).then(__webpack_require__.bind(__webpack_require__, 95778));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(95778)
            ];
        }
    }
});
var CaseAppFeatures = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(15680), __webpack_require__.e(6310)]).then(__webpack_require__.bind(__webpack_require__, 6310));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6310)
            ];
        }
    }
});
var CaseFeaturesSection = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(15680), __webpack_require__.e(90226)]).then(__webpack_require__.bind(__webpack_require__, 90226));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(90226)
            ];
        }
    }
});
var CaseFullScreenImages = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(95734)]).then(__webpack_require__.bind(__webpack_require__, 95734));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(95734)
            ];
        }
    }
});
var CaseEvent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(85586)]).then(__webpack_require__.bind(__webpack_require__, 85586));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(85586)
            ];
        }
    }
});
var CaseStudiesStory = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(15680), __webpack_require__.e(95791)]).then(__webpack_require__.bind(__webpack_require__, 95791));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(95791)
            ];
        }
    }
});
var CaseProcess = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(15680), __webpack_require__.e(6778), __webpack_require__.e(96366), __webpack_require__.e(75847)]).then(__webpack_require__.bind(__webpack_require__, 96366));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(96366)
            ];
        }
    }
});
var CasePrototype = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(53662), __webpack_require__.e(25675), __webpack_require__.e(19785)]).then(__webpack_require__.bind(__webpack_require__, 19785));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(19785)
            ];
        }
    }
});
var CaseFeedback = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 99839).then(__webpack_require__.bind(__webpack_require__, 99839));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(99839)
            ];
        }
    }
});
var CardsSection = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(15680), __webpack_require__.e(30719), __webpack_require__.e(27265), __webpack_require__.e(44709)]).then(__webpack_require__.bind(__webpack_require__, 27265));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(27265)
            ];
        }
    }
});
var ProcessSection = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(38055), __webpack_require__.e(35845), __webpack_require__.e(35858)]).then(__webpack_require__.bind(__webpack_require__, 35845));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(35845)
            ];
        }
    }
});
var TabsSection = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(30719), __webpack_require__.e(61775)]).then(__webpack_require__.bind(__webpack_require__, 76974));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(76974)
            ];
        }
    }
});
var CaseStudiesCommon = function(props) {
    switch(props.data.type){
        case constants/* CASE_STUDIES_TYPES.intro */.vA.intro:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(IntroRefactored, (0,_object_spread/* default */.Z)({}, props));
        case constants/* CASE_STUDIES_TYPES.projectIdea */.vA.projectIdea:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProjectIdeaRefactored, (0,_object_spread/* default */.Z)({}, props));
        case constants/* CASE_STUDIES_TYPES.results */.vA.results:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ResultsSectionRefactored, (0,_object_spread/* default */.Z)({}, props));
        case constants/* CASE_STUDIES_TYPES.appFeatures */.vA.appFeatures:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CaseAppFeatures, (0,_object_spread/* default */.Z)({}, props));
        case constants/* CASE_STUDIES_TYPES.image */.vA.image:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ImagesSectionRefactored, (0,_object_spread/* default */.Z)({}, props));
        case constants/* CASE_STUDIES_TYPES.wireframe */.vA.wireframe:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(WireframesSectionRefactored, (0,_object_spread/* default */.Z)({}, props));
        case constants/* CASE_STUDIES_TYPES.specialChallenges */.vA.specialChallenges:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SpecialChallengesAndSolutionsRefactored, (0,_object_spread/* default */.Z)({}, props));
        case constants/* CASE_STUDIES_TYPES.challenges */.vA.challenges:
        case constants/* CASE_STUDIES_TYPES.challengesSlider */.vA.challengesSlider:
        case constants/* CASE_STUDIES_TYPES.challengesSpecialSlider */.vA.challengesSpecialSlider:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ChallengesAndSolutionsWithWireframesRefactored, (0,_object_spread/* default */.Z)({}, props));
        case constants/* CASE_STUDIES_TYPES.parallax */.vA.parallax:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CaseParallax, (0,_object_spread/* default */.Z)({}, props));
        case constants/* CASE_STUDIES_TYPES.feedback */.vA.feedback:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CaseFeedback, (0,_object_spread/* default */.Z)({}, props));
        case constants/* CASE_STUDIES_TYPES.design */.vA.design:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CaseStudyDesign, (0,_object_spread/* default */.Z)({}, props));
        case constants/* CASE_STUDIES_TYPES.features */.vA.features:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CaseFeaturesSection, (0,_object_spread/* default */.Z)({}, props));
        case constants/* CASE_STUDIES_TYPES.fullscreenImage */.vA.fullscreenImage:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CaseFullScreenImages, (0,_object_spread/* default */.Z)({}, props));
        case constants/* CASE_STUDIES_TYPES.caseStudyEvent */.vA.caseStudyEvent:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CaseEvent, (0,_object_spread/* default */.Z)({}, props));
        case constants/* CASE_STUDIES_TYPES.story */.vA.story:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CaseStudiesStory, (0,_object_spread/* default */.Z)({}, props));
        case constants/* CASE_STUDIES_TYPES.process */.vA.process:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CaseProcess, (0,_object_spread/* default */.Z)({}, props));
        case constants/* CASE_STUDIES_TYPES.prototype */.vA.prototype:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CasePrototype, (0,_object_spread/* default */.Z)({}, props));
        case constants/* CASE_STUDIES_TYPES.cards */.vA.cards:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CardsSection, (0,_object_spread/* default */.Z)({}, props));
        case constants/* CASE_STUDIES_TYPES.tabs */.vA.tabs:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsSection, (0,_object_spread/* default */.Z)({}, props));
        case constants/* CASE_STUDIES_TYPES.cardsWithOverlay */.vA.cardsWithOverlay:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CardsSection, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                withOverlay: true
            }));
        case constants/* CASE_STUDIES_TYPES.processWithArrays */.vA.processWithArrays:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProcessSection, (0,_object_spread/* default */.Z)({}, props));
        default:
            return null;
    }
};
/* harmony default export */ var components_CaseStudiesCommon = (CaseStudiesCommon);

// EXTERNAL MODULE: ./components/Common/MetaTags/index.jsx + 4 modules
var MetaTags = __webpack_require__(36003);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
// EXTERNAL MODULE: ./utils/routes.js
var routes = __webpack_require__(27727);
// EXTERNAL MODULE: ./redux/apis/page.js
var page = __webpack_require__(85144);
// EXTERNAL MODULE: ./utils/breadcrumbs.js
var utils_breadcrumbs = __webpack_require__(84047);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./containers/CaseStudies/styles.module.scss
var styles_module = __webpack_require__(18907);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./UI/components/LinkWrapper/index.jsx + 2 modules
var LinkWrapper = __webpack_require__(56362);
// EXTERNAL MODULE: ./UI/components/Typography/index.jsx
var Typography = __webpack_require__(59654);
// EXTERNAL MODULE: ./utils/constants/contacts.js
var contacts = __webpack_require__(32522);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/lodash/last.js
var last = __webpack_require__(10928);
var last_default = /*#__PURE__*/__webpack_require__.n(last);
;// CONCATENATED MODULE: ./UI/sections/CaseStudiesFooter/utils/data.js

var data_socialNetworks = Object.values(contacts/* SOCIAL_MEDIA */.CL).filter(function(param) {
    var id = param.id;
    return [
        "behance",
        "dribbble",
        "instagram", 
    ].includes(id);
});
var CASES_BLACK_ICONS = [
    "open-sense",
    "tell"
];

;// CONCATENATED MODULE: ./UI/sections/CaseStudiesFooter/utils/useCaseStudiesFooter.js





var useCaseStudiesFooter = function(param) {
    var type = param.type, pathname = param.pathname;
    var ref = (0,page/* useFetchPageQuery */.o)(type), tmp = ref.data, contentModules = (tmp === void 0 ? {} : tmp).contentModules;
    var lastContentModule = last_default()(contentModules);
    var ref1 = (0,helper/* getDocumentFields */.OA)(lastContentModule, [
        "background",
        "contentModules"
    ]), background = ref1.background, footerContentModules = ref1.contentModules;
    var ref2 = (0,helper/* getDocumentFields */.OA)(get_default()(footerContentModules, "[0]", {}), [
        "title",
        "buttonTitle",
        "slug", 
    ]), title = ref2.title, buttonTitle = ref2.buttonTitle, slug = ref2.slug;
    var footerBackgroundImage = (0,helper/* getOptimizedContentfulImage */.kd)((0,helper/* getFileUrl */.qm)(background), {
        fm: "png"
    });
    var footerStyle = footerBackgroundImage ? {
        backgroundImage: "url(".concat(footerBackgroundImage, ")")
    } : {};
    var socialNetworks = data_socialNetworks.map(function(item) {
        return {
            name: item.title,
            icon: CASES_BLACK_ICONS.includes(type) ? item.iconDark : item.iconLight,
            href: item.link
        };
    });
    return {
        type: type,
        title: title,
        buttonTitle: buttonTitle,
        slug: slug,
        pathname: pathname,
        footerStyle: footerStyle,
        socialNetworks: socialNetworks
    };
};

// EXTERNAL MODULE: ./UI/sections/CaseStudiesFooter/styles.module.scss
var CaseStudiesFooter_styles_module = __webpack_require__(6893);
var CaseStudiesFooter_styles_module_default = /*#__PURE__*/__webpack_require__.n(CaseStudiesFooter_styles_module);
;// CONCATENATED MODULE: ./UI/sections/CaseStudiesFooter/index.jsx










var SectionTitle = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 15805).then(__webpack_require__.bind(__webpack_require__, 15805));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(15805)
            ];
        }
    }
});
var Svg = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6778).then(__webpack_require__.bind(__webpack_require__, 6778));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6778)
            ];
        }
    }
});
var CaseStudiesFooter = function(props) {
    var ref = useCaseStudiesFooter(props), type = ref.type, title = ref.title, buttonTitle = ref.buttonTitle, slug = ref.slug, pathname = ref.pathname, footerStyle = ref.footerStyle, socialNetworks = ref.socialNetworks;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
        className: classnames_default()((CaseStudiesFooter_styles_module_default())[type], (CaseStudiesFooter_styles_module_default()).footer),
        style: footerStyle,
        children: [
            slug && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (CaseStudiesFooter_styles_module_default()).nextProjectContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle, {
                        title: "Next project",
                        description: title,
                        className: (CaseStudiesFooter_styles_module_default()).sectionTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(LinkWrapper/* default */.Z, {
                        path: slug,
                        className: (CaseStudiesFooter_styles_module_default()).more,
                        isLocalLink: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography["default"], {
                                className: (CaseStudiesFooter_styles_module_default()).textIndent,
                                children: buttonTitle
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg, {
                                type: constants/* SVG_IMAGES_TYPES.arrow */.NL.arrow
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (CaseStudiesFooter_styles_module_default()).footerLinks,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (CaseStudiesFooter_styles_module_default()).emailContainer,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography["default"], {
                                variant: "p",
                                className: (CaseStudiesFooter_styles_module_default()).question,
                                children: "Not sure where to start?"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper/* default */.Z, {
                                path: "mailto:".concat(contacts/* EMAIL_LINK */.Vr),
                                className: (CaseStudiesFooter_styles_module_default()).link,
                                isLocalLink: true,
                                googleAnalyticProps: {
                                    action: "Click",
                                    data: "Email"
                                },
                                children: contacts/* EMAIL_LINK */.Vr
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: socialNetworks.map(function(param) {
                            var name = param.name, href = param.href, icon = param.icon;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper/* default */.Z, {
                                path: href,
                                className: (CaseStudiesFooter_styles_module_default()).iconLink,
                                googleAnalyticProps: {
                                    category: "Social",
                                    label: pathname,
                                    data: name
                                },
                                isSocialLink: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg, {
                                    type: icon
                                })
                            }, "networks/".concat(name));
                        })
                    })
                ]
            })
        ]
    });
};
CaseStudiesFooter.propTypes = {
    type: (prop_types_default()).string.isRequired,
    pathname: (prop_types_default()).string.isRequired
};
/* harmony default export */ var sections_CaseStudiesFooter = (CaseStudiesFooter);

;// CONCATENATED MODULE: ./containers/CaseStudies/index.jsx













var CaseStudiesContainer = function(param) {
    var introSection = param.introSection, slug = param.slug;
    var ref = (0,page/* useFetchPageQuery */.o)(slug), _data = ref.data, data = _data === void 0 ? {} : _data, isLoading = ref.isLoading;
    var asPath = (0,router.useRouter)().asPath;
    if (isLoading) {
        return null;
    }
    var contentModules = data.contentModules, pageTitle = data.pageTitle, _metaData = data.metaData, metaTitle = _metaData.metaTitle, metaDescription = _metaData.metaDescription, ogImage = _metaData.ogImage, metaRobots = _metaData.metaRobots;
    var projectMetadata = {
        metaTitle: metaTitle || "".concat(pageTitle, " | Yellow"),
        metaDescription: metaDescription || pageTitle && "Yellow professionals have created ".concat(pageTitle, ". Read our case study to find more!"),
        url: "".concat(helper/* rootUrl */.Wd).concat(routes/* routes.portfolio.getRoute */._.portfolio.getRoute(slug).path),
        metaRobots: metaRobots,
        ogImage: ogImage
    };
    // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! DONT FORGET TO USE IT DURING RESOLVING MERGE CONFLICT !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
    var breadcrumbs = (0,utils_breadcrumbs/* getBreadcrumbs */.Z)(constants/* PAGES.project */.q5.project, {
        slug: slug,
        title: pageTitle
    });
    // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! DONT FORGET TO USE IT DURING RESOLVING MERGE CONFLICT !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTags/* default */.Z, {
                page: constants/* PAGES.portfolio */.q5.portfolio,
                pageMetadata: projectMetadata,
                breadcrumbs: breadcrumbs
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                className: classnames_default()((styles_module_default()).main, (styles_module_default())[slug]),
                children: [
                    contentModules === null || contentModules === void 0 ? void 0 : contentModules.map(function(param) {
                        var fields = param.fields, sys = param.sys;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CaseStudiesCommon, {
                            type: slug,
                            introSection: introSection,
                            data: fields
                        }, sys.id);
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(sections_CaseStudiesFooter, {
                        type: slug,
                        pathname: asPath
                    })
                ]
            })
        ]
    });
};
CaseStudiesContainer.propTypes = {
    introSection: prop_types_default().instanceOf(Object).isRequired
};
/* harmony default export */ var CaseStudies = (CaseStudiesContainer);

;// CONCATENATED MODULE: ./pages/works/[project].js




var Project = function(_param) /*#__PURE__*/ {
    var introSection = _param.introSection, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "introSection"
    ]);
    return (0,jsx_runtime.jsx)(CaseStudies, (0,_object_spread/* default */.Z)({
        introSection: introSection
    }, rest));
};
var __N_SSP = true;
/* harmony default export */ var _project_ = (Project);


/***/ }),

/***/ 85144:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ useFetchPageQuery; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var utils_helper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6572);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91555);




var pageApi = ___WEBPACK_IMPORTED_MODULE_0__["default"].injectEndpoints({
    endpoints: function(builder) {
        return {
            fetchPage: builder.query({
                extraOptions: {
                    type: ___WEBPACK_IMPORTED_MODULE_0__.BASEQUERY_TYPES.getEntries
                },
                query: function(slug) {
                    return {
                        contentType: "page",
                        additionalQueryParams: {
                            "fields.slug": slug
                        }
                    };
                },
                transformResponse: function transformResponse(response, _, arg) {
                    if (!arg || typeof arg !== "string") {
                        return {
                            data: {}
                        };
                    }
                    var data = response.items[0].fields;
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, data), {
                        metaData: {
                            metaTitle: data.metaTitle || "",
                            metaDescription: data.metaDescription || "",
                            metaRobots: data.metaRobots || "",
                            ogImage: (0,utils_helper__WEBPACK_IMPORTED_MODULE_3__/* .getFileUrl */ .qm)(data.ogImage)
                        }
                    });
                }
            })
        };
    }
});
var useFetchPageQuery = pageApi.useFetchPageQuery;
/* harmony default export */ __webpack_exports__["Z"] = (pageApi);


/***/ }),

/***/ 19341:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bw": function() { return /* binding */ selectIsSmallTablet; },
/* harmony export */   "Tr": function() { return /* binding */ selectIsPageReadyToDisplay; },
/* harmony export */   "Y6": function() { return /* binding */ selectIsDesktop; },
/* harmony export */   "aT": function() { return /* binding */ selectIsTablet; },
/* harmony export */   "cF": function() { return /* binding */ selectIsFirstPageLoaded; },
/* harmony export */   "eD": function() { return /* binding */ selectIsMobile; },
/* harmony export */   "qL": function() { return /* binding */ selectIsMobileCategotiesOpened; }
/* harmony export */ });
var selectIsMobileCategotiesOpened = function(state) {
    return state.layout.isMobileCategotiesOpened;
};
var selectIsPageReadyToDisplay = function(state) {
    return state.layout.isPageReadyToDisplay;
};
var selectIsFirstPageLoaded = function(state) {
    return state.layout.isFirstPageLoaded;
};
var selectIsMobile = function(state) {
    return state.layout.isMobileResolution;
};
var selectIsTablet = function(state) {
    return state.layout.isTabletResolution;
};
var selectIsSmallTablet = function(state) {
    return state.layout.isSmallTabletResolution;
};
var selectIsDesktop = function(state) {
    return state.layout.isDesktopResolution;
};


/***/ }),

/***/ 84047:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getBreadcrumbs; }
/* harmony export */ });
/* harmony import */ var utils_helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6572);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96076);


function getBreadcrumbs(page) {
    var ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, title = ref.title, slug = ref.slug, tagsList = ref.tagsList;
    var currentRoute = Object.values(utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES */ .y2).find(function(route) {
        return route.slug === page;
    });
    var breadcrumbs = [
        {
            to: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.homepage.path */ .y2.homepage.path,
            title: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.homepage.title */ .y2.homepage.title
        }, 
    ];
    switch(currentRoute.slug){
        case utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.blog.slug */ .y2.blog.slug:
            breadcrumbs.push({
                to: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.blog.path */ .y2.blog.path,
                title: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.blog.title */ .y2.blog.title
            });
            if (slug && !(0,utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .isNumeric */ .kE)(slug)) {
                var tag = tagsList === null || tagsList === void 0 ? void 0 : tagsList.find(function(param) {
                    var tagSlug = param.slug;
                    return tagSlug === slug;
                });
                breadcrumbs.push({
                    to: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.blog.getRoute */ .y2.blog.getRoute(slug).path,
                    title: tag === null || tag === void 0 ? void 0 : tag.title
                });
            }
            return breadcrumbs;
        case utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.project.slug */ .y2.project.slug:
            breadcrumbs.push({
                to: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.portfolio.path */ .y2.portfolio.path,
                title: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.portfolio.title */ .y2.portfolio.title
            });
            if (title && slug) {
                breadcrumbs.push({
                    to: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.project.getRoute */ .y2.project.getRoute(slug).path,
                    title: title
                });
            }
            return breadcrumbs;
        case utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.article.slug */ .y2.article.slug:
            breadcrumbs.push({
                to: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.blog.path */ .y2.blog.path,
                title: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.blog.title */ .y2.blog.title
            });
            if (title && slug) {
                breadcrumbs.push({
                    to: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.article.getRoute */ .y2.article.getRoute(slug).path,
                    title: title
                });
            }
            return breadcrumbs;
        case utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.person.slug */ .y2.person.slug:
            breadcrumbs.splice(0, 1);
            breadcrumbs.push({
                to: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.blog.path */ .y2.blog.path,
                title: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.blog.title */ .y2.blog.title
            });
            if (title && slug) {
                breadcrumbs.push({
                    to: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.person.getRoute */ .y2.person.getRoute(slug).path,
                    title: title
                });
            }
            return breadcrumbs;
        default:
            breadcrumbs.push({
                to: currentRoute.path,
                title: currentRoute.title
            });
            return breadcrumbs;
    }
}


/***/ }),

/***/ 34461:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"boldText":"styles_boldText__iI9uz","headline-xl":"styles_headline-xl__HRBMS","headline-l":"styles_headline-l__Veh_x","headline-m":"styles_headline-m__gfh2N","headline-s":"styles_headline-s___kodX","headline-xs":"styles_headline-xs__XhN56","paragrapgh-m":"styles_paragrapgh-m__QFKni","paragrapgh-s":"styles_paragrapgh-s__4Eq1X","caption":"styles_caption__y7HHJ"};

/***/ }),

/***/ 6893:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__PFWKN","contentWrapper":"styles_contentWrapper__xTBVi","nextProjectContainer":"styles_nextProjectContainer__solM4","sectionTitle":"styles_sectionTitle__zQvM7","more":"styles_more__ZD027","question":"styles_question__DDOsx","link":"styles_link__xsQEV","iconLink":"styles_iconLink__S15zr","footerLinks":"styles_footerLinks__TW_BU","emailContainer":"styles_emailContainer__ZYbuJ","stickerbox":"styles_stickerbox__Gd3Rs","fireaway":"styles_fireaway__jvfn7","fairy":"styles_fairy__tCAVG","seven-pm-thursday":"styles_seven-pm-thursday__txsuI","fernwayer":"styles_fernwayer__9yOjO","drive-focus":"styles_drive-focus__IUsnh","hotel-data-cloud":"styles_hotel-data-cloud__lr_K8","open-sense":"styles_open-sense__mouoE","separate-us":"styles_separate-us__ccQtZ","famlicious":"styles_famlicious__dnBmg","natp":"styles_natp__aioJt","travel-trivia":"styles_travel-trivia__HFF4Q","cash-chat":"styles_cash-chat__Fx_Gk","tell":"styles_tell__smGtq","ubichat":"styles_ubichat__c_tfe","writer-chrome-extension":"styles_writer-chrome-extension__yfShI","meateater":"styles_meateater__tv4TS","bionorica":"styles_bionorica__Xw4bH","marketplace-for-clairvoyant-services":"styles_marketplace-for-clairvoyant-services__ltq_M","fusion-markets":"styles_fusion-markets__HznRX","beautonomy":"styles_beautonomy__xPlVv","telemojo":"styles_telemojo__mH_jZ","blackbird":"styles_blackbird__UIWRH","fintech-app-for-credit-score":"styles_fintech-app-for-credit-score__8aVws","smartcenter":"styles_smartcenter__Dft52","dindon":"styles_dindon__P3O4u","humankind":"styles_humankind__mfqIK","cinnabar":"styles_cinnabar__d7ZcM","machine-learning-in-real-estate":"styles_machine-learning-in-real-estate__gfvvJ","mobile-bank-application":"styles_mobile-bank-application__8x8sy","software-for-mri-interpretation":"styles_software-for-mri-interpretation__uVU3a","cedar-valley-farms":"styles_cedar-valley-farms__Gxluj","mobile-budgeting-app":"styles_mobile-budgeting-app__R49L7","forex-trading-platform":"styles_forex-trading-platform__8a5uz","crowdfunding-platform":"styles_crowdfunding-platform__Lb3LU","cctv-footage-analytics":"styles_cctv-footage-analytics__N74yG","analytics-for-carbon-tracking":"styles_analytics-for-carbon-tracking__giMLh","web-chat-for-mediums":"styles_web-chat-for-mediums__wUcJe","web-p2p-lending-platform":"styles_web-p2p-lending-platform__ajcpo","kitchen-equipment-customizer":"styles_kitchen-equipment-customizer__patKP","mobile-music-app":"styles_mobile-music-app__uEMaO","clairvoyant-directory-upgrade":"styles_clairvoyant-directory-upgrade__1Mxvk","digital-wallet-for-ios":"styles_digital-wallet-for-ios__ugOL3","enterprise-resource-planning-system":"styles_enterprise-resource-planning-system__4dyVL","medical-software-for-musculoskeletal-rehabilitation":"styles_medical-software-for-musculoskeletal-rehabilitation__8uOvR","restaurant-asset-management-tool":"styles_restaurant-asset-management-tool__RlDLu","custom-payment-gateway":"styles_custom-payment-gateway__C5wJC","ai-documentation-processing":"styles_ai-documentation-processing__onaWM","ai-mobile-cooking-app":"styles_ai-mobile-cooking-app__WphYi","ai-based-travel-planner":"styles_ai-based-travel-planner__Gn4AW","ai-streamlined-recruitment-process":"styles_ai-streamlined-recruitment-process__ly2wD","writer-framework-platform":"styles_writer-framework-platform__WMFMY","computer-vision-for-aras":"styles_computer-vision-for-aras__31HCA","enhancing-money-laundering-mention-extraction":"styles_enhancing-money-laundering-mention-extraction__nfr_c"};

/***/ }),

/***/ 18907:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__y8d_O","writer-framework-platform":"styles_writer-framework-platform__d5Piv"};

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [36003,49774,92888,40179], function() { return __webpack_exec__(41910); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);